import React from 'react'
import { times } from 'lodash'

const SkeletonText = ({ words = 1, wordLength = 5, ...props }) => (
  <span style={{ opacity: 0.1 }}>{times(words).map(() => times(wordLength).map(() => `\u2586`).join('')).join(' ')}</span>
)

SkeletonText.displayName = 'SkeletonText'

export default SkeletonText



// WEBPACK FOOTER //
// ./components/Customers/presentational/SkeletonText.js